import { useState, useEffect } from 'react';
import { postRecommend } from '@doda/common/src/services/postRecommend';
import type { RecommendPanel } from '@doda/common/src/interfaces/api/recommendPanel';

/** レコメンド結果のインターフェース */
interface RecommendResult {
  /** スライダー用のレコメンドパネル */
  recommendForSlider: RecommendPanel | null;
  /** リスト用のレコメンドパネル */
  recommendForList: RecommendPanel | null;
}

/** 初期状態のレコメンド結果 */
const initialState: RecommendResult = {
  recommendForSlider: null,
  recommendForList: null,
};

/**
 * レコメンドセクションのカスタムフック
 *
 * @returns {RecommendResult} レコメンド結果
 */
export function useRecommendSection(): RecommendResult {
  const [data, setData] = useState<RecommendResult>(initialState);

  useEffect(() => {
    (async () => {
      try {
        const res1 = await postRecommend({
          ...DEFAULT_FORM_DATA.list,
          location: window.location.href,
        });
        // APIエラー/データが無い場合どちらもまとめて2度目の通信を行うためにthrowする
        if (!res1.data) throw new Error('no response');
        // データがある場合
        setData((prev) => ({ ...prev, recommendForList: res1.data }));
      } catch {
        try {
          const res2 = await postRecommend({
            ...DEFAULT_FORM_DATA.slider,
            location: window.location.href,
          });
          if (res2.data)
            setData((prev) => ({ ...prev, recommendForSlider: res2.data }));
        } catch {
          // 両方のリクエストでデータが取得できない場合は非表示
        }
      }
    })();
  }, []);

  return data;
}

/** デフォルトのリクエストデータ */
const DEFAULT_FORM_DATA = {
  slider: {
    recommendType:
      'AWS_Recommend_oubo,AWS_Recommend_etsuran,view_list,ranking_ocl,ranking_all',
    dispType: 'json',
    effectEventId: 'event70,event70,event70,event70,event70',
    effectPosition: 'Rekome_pc,Rekome_pc,Rekome_pc,Rekome_pc,Rekome_pc',
    effectName:
      'default_AWS_Recommend_oubo,default_AWS_Recommend_etsuran,default_view_list,default_ranking_ocl,default_ranking_all',
    conditionItems: '',
  },
  list: {
    recommendType: 'AWS_Recommend_oubo,AWS_Recommend_etsuran,view_list',
    dispType: 'json',
    effectEventId: 'event70,event70,event70',
    effectPosition: 'Rekome_pc,Rekome_pc,Rekome_pc',
    effectName:
      'KensakuKekka_Rekome_Oubo_ChikaiKyujin_pc,KensakuKekka_Rekome_Etsuran_ChikaiKyujin_pc,KensakuKekka_Rekome_Etsuran_Kyujin_pc',
    conditionItems: '',
  },
};
